var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pui-button',_vm._g({class:{
    'pui-thumbnail-action pui-thumbnail-action__root': true,
    'action-active': _vm.active,
    disabled: _vm.disabled,
  },attrs:{"picto":_vm.loading ? null : _vm.picto,"disabled":_vm.disabled,"variant":"secondary"}},_vm.$listeners),[(_vm.loading)?_c('pui-common-spinner',{attrs:{"size":20,"strokeWidth":2,"hideMessage":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }